import { freeze } from '@reduxjs/toolkit';
import { appRoutes, ISidebarLink } from '../../../path';

export const adminSettingsLinks = freeze<ISidebarLink[]>(
  [
    {
      title: 'Plan Details',
      url: appRoutes.permission.planDetails,
    },
    {
      title: 'Users',
      url: appRoutes.permission.users,
    },
    {
      title: 'Groups',
      url: appRoutes.permission.userGroups,
    },
    {
      title: 'Roles',
      url: appRoutes.permission.roles,
    },
    {
      title: 'Settings',
      url: appRoutes.permission.settings,
    },
    {
      title: 'Notifications',
      url: appRoutes.permission.notifications,
    },
  ],
  true,
);

export const personalSettingsLinks = freeze<ISidebarLink[]>(
  [
    {
      title: 'My Profile',
      url: appRoutes.settings.myProfile,
    },
    {
      title: 'Preferences',
      url: appRoutes.settings.preferences,
    },
  ],
  true,
);
